<template>
  <div class="container">
    <BaseFrame
    :able='able'
    @save='submit'
    @clear='clear'
    @cancel='cancel'
    save-text="保存"
    >
      <div slot="content">
        <lk-form
          :model="branchForm.stocktakingPlan"
          label-position="right"
          :label-width="130"
          :rules="ruleValidate"
          ref="branchForm.sysDept"
        >
          <div class="cardContainer">
            <lk-card title="盘点信息">
              <lk-row :gutter="16">
                <lk-col span="11">
                  <lk-form-item label="盘点名称:" prop="name">
                    <span>{{branchForm.name}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="11">
                  <lk-form-item label="盘点仓库:" prop="warehouseName">
                    <span>{{branchForm.warehouseName}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="11">
                  <lk-form-item label="是否含0库存商品:" prop="hasZero">
                    <span>{{branchForm.hasZero}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="11">
                  <lk-form-item label="盘点人员:" prop='operatorName'>
                    <span>{{branchForm.operatorName}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="11">
                  <lk-radio-group v-model="branchForm.radio">
                    <lk-radio label="1">所有商品</lk-radio>
                    <lk-radio label="2">选择商品</lk-radio>
                  </lk-radio-group>
                  <lk-button v-if="branchForm.radio == '2'" type="primary" size="small"
                             @click="chooseGoods">选择商品</lk-button>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
    <DTPModal
    v-model="showClear"
    @confirm='confirmClear'
    content='重置将取消当前所做更改。'
    >
    </DTPModal>
    <lk-modal
      v-model="showModal"
      title="选择商品"
      width="900">
      <div class="clear">
        <div>
          <div class="queryContainer">
            <div class="queryItem">
              <label>关键词:</label>
              <lk-input :maxlength='40' placeholder='商品编码、助记码、商品名称、通用名称' class="item" clearable v-model.trim='modalQueryParams.text'></lk-input>
            </div>
            <div class="queryItem">
              <lk-button type='primary' class="mr" @click="getInventorData">查询</lk-button>
              <lk-button @click="clearModalQuery">重置</lk-button>
            </div>
          </div>
        </div>
      <div style="width:46%; float: left;">
          <lk-table ref="selection" border :columns='modalColumns' :data='modalTableData'
                    @on-selection-change="handleModalSelect"></lk-table>
      </div>
      <div style="float: left; width: 5%;">
        <lk-button class="mr" @click="addData">&gt;</lk-button>
        <lk-button @click="removeData">&lt;</lk-button>
      </div>
      <div style="width:46%; float: left;">

        <lk-table border :columns='addColumns' :data='addTableData'
                  @on-selection-change="handleAddSelect"></lk-table>
      </div>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <span style="padding-right: 16px;">已选:{{this.addTableData.length}}项</span>
          <lk-button @click="clearModal">取消</lk-button>
          <lk-button type='primary' class="mr" @click="hideModal">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import DTPModal from '../../components/DTPModal.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
export default {
  name: 'stocktaking',
  components: {
    BaseFrame,
    DTPModal,
  },
  data() {
    return {
      queryParams: {
        name: '',
        drugSerialCode: '',
      },
      modalQueryParams: {
        text: null,
      },
      modalSelection: [],
      modalTableData: [],
      addSelection: [],
      addTableData: [],
      addMap: {},
      showModal: false,
      showClear: false,
      able: false,
      hasZeroMap: {
        1: '是',
        2: '否',
      },
      branchForm: {
        name: '',
        radio: '1',
      },
      ruleValidate: {
      },
      modalColumns: [
        {
          title: '选择', key: 'id', type: 'selection', width: 60,
        },
        { title: '商品编码', key: 'inventoryExpireDrugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'inventoryExpireGoodsName', minWidth: 110 },
        { title: '通用名称', key: 'inventoryExpireApprovedDrugNames', minWidth: 110 },
        { title: '规格', key: 'inventoryExpireSpecifications', minWidth: 110 },
        { title: '剂型', key: 'inventoryExpireDosageForm', minWidth: 110 },
        { title: '单位', key: 'inventoryExpireDrugMiniPackageUnit', minWidth: 110 },
        // { title: '生产厂家', key: 'inventoryExpireManufacturer', minWidth: 110 },
        // { title: '商品状态', key: 'inventoryExpireGoodsStoreStatusStr', minWidth: 110 },
        // { title: '仓库', key: 'inventoryExpireWarehouseName', minWidth: 110 },
        // { title: '货位', key: 'inventoryExpireLocationCode', minWidth: 110 },
        // { title: '数量', key: 'inventoryExpireGoodsStockAmount', minWidth: 110 },
        // { title: '批次', key: 'inventoryExpireGoodsBatchSeq', minWidth: 110 },
        // { title: '批号', key: 'inventoryExpireGoodsBatchNumber', minWidth: 110 },
        // { title: '入库日期', key: 'inventoryExpireCreateTime', minWidth: 120 },
        // { title: '生产日期', key: 'inventoryExpireGoodsProductionDate', minWidth: 120 },
        // { title: '有效日期', key: 'inventoryExpireGoodsExpiryDate', minWidth: 120 },
        // { title: '有效天数', key: 'inventoryExpireBeforeExpireDays', minWidth: 120 },
        // { title: '预警天数', key: 'inventoryExpirePeriodAlertDays', minWidth: 120 },
      ],
      modalPage: 1,
      modalSize: 10,
      modalCount: 0,
      addColumns: [
        {
          title: '选择', key: 'id', type: 'selection', width: 60,
        },
        { title: '商品编码', key: 'inventoryExpireDrugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'inventoryExpireGoodsName', minWidth: 110 },
        { title: '通用名称', key: 'inventoryExpireApprovedDrugNames', minWidth: 110 },
        { title: '规格', key: 'inventoryExpireSpecifications', minWidth: 110 },
        { title: '剂型', key: 'inventoryExpireDosageForm', minWidth: 110 },
        { title: '单位', key: 'inventoryExpireDrugMiniPackageUnit', minWidth: 110 },
        // { title: '生产厂家', key: 'inventoryExpireManufacturer', minWidth: 110 },
        // { title: '商品状态', key: 'inventoryExpireGoodsStoreStatusStr', minWidth: 110 },
        // { title: '仓库', key: 'inventoryExpireWarehouseName', minWidth: 110 },
        // { title: '货位', key: 'inventoryExpireLocationCode', minWidth: 110 },
        // { title: '数量', key: 'inventoryExpireGoodsStockAmount', minWidth: 110 },
        // { title: '批次', key: 'inventoryExpireGoodsBatchSeq', minWidth: 110 },
        // { title: '批号', key: 'inventoryExpireGoodsBatchNumber', minWidth: 110 },
        // { title: '入库日期', key: 'inventoryExpireCreateTime', minWidth: 120 },
        // { title: '生产日期', key: 'inventoryExpireGoodsProductionDate', minWidth: 120 },
        // { title: '有效日期', key: 'inventoryExpireGoodsExpiryDate', minWidth: 120 },
        // { title: '有效天数', key: 'inventoryExpireBeforeExpireDays', minWidth: 120 },
        // { title: '预警天数', key: 'inventoryExpirePeriodAlertDays', minWidth: 120 },
      ],
    };
  },
  methods: {
    getData() {
      inventory.getStocktakingPlanByd(this.$route.params.id)
        .then((res) => {
          if (res.data.status === 200) {
            this.branchForm.name = res.data.data.name;
            this.branchForm.warehouseName = res.data.data.warehouseName;
            this.branchForm.hasZero = this.hasZeroMap[res.data.data.hasZero];
            this.branchForm.operatorName = res.data.data.operatorName;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getInventorData() {
      const params = {};
      params.page = this.page;
      params.size = this.size;
      if (this.modalQueryParams.text) {
        params.text = this.modalQueryParams.text;
      }

      inventory.expireSearch(params).then((res) => {
        if (res.data.status === 200) {
          this.modalTableData = [];
          this.count = res.data.data.count;
          res.data.data.forEach((item, index) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.id = `${result.inventoryExpireId},${index}`;
            result.index = index + 1;
            this.modalTableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    submit() { // 验证函数
      if (this.branchForm.radio === '1') {
        inventory.addAllStocktakingRecords({ stocktakingPlanId: Number.parseInt(this.$route.params.id, 10) })
          .then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('操作成功');
              this.cancel();
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
      } else if (this.addTableData.length > 0) {
        const stocktakingRecords = [];
        const stocktakingRecord = {};
        const stocktakingPlanId = this.$route.params.id;
        this.addTableData.forEach((item) => {
          stocktakingRecord.inventoryId = item.inventoryExpireId;
          stocktakingRecord.stocktakingPlanId = stocktakingPlanId;
          stocktakingRecords.push(stocktakingRecord);
        });
        inventory.addStocktakingRecords({ stocktakingRecords }).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('操作成功');
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else {
        this.$Message.error('请选择需要盘点的商品');
      }
    },
    setAble(val) { // frame判定框架是否支持录入
      this.able = val;
      if (!this.able) {
        this.$set(this.ruleValidate, null);
        // this.ruleValidate = null;
      }
    },
    confirmClear() { // 确认重置
      this.$refs['branchForm.sysDept'].resetFields();
      this.branchForm = {
      };
      this.showClear = false;
    },
    clear() {
      this.showClear = true;
      // this.$refs['branchForm.sysDept'].resetFields();
    },
    cancel() {
      this.$router.go(-1);
    },
    chooseGoods() {
      // alert('快来帮我写transfer-table啊！！！');
      this.showModal = true;
      this.getInventorData();
    },
    handleModalPage(page) {
      this.page = page;
      this.getData();
    },
    handleModalPageSize(size) {
      this.size = size;
      this.getData();
    },
    handleModalSelect(selection) {
      this.modalSelection = selection;
    },
    handleAddSelect(selection) {
      this.addSelection = selection;
    },
    clearModalQuery() {
      this.modalSelection = [];
      this.modalQueryParams = {};
    },
    clearModal() {
      this.hideModal();
      this.clearModalQuery();
      // this.modalTableData = [];
    },
    hideModal() {
      this.showModal = false;
    },
    addData() {
      if (this.modalSelection.length > 0) {
        const goodsNames = [];
        this.modalSelection.forEach((item) => {
          if (!this.addMap[item.id]) {
            this.addTableData.push(item);
            this.addMap[item.id] = true;
          } else {
            goodsNames.push(item.inventoryExpireGoodsName);
          }
        });
        if (goodsNames.length > 0) {
          this.$Message.error(`已选择商品：${goodsNames}`);
        }
        this.$refs.selection.selectAll(false);
      } else {
        this.$Message.error('请选择需要盘点的商品!');
      }
    },
    removeData() {
      if (this.addSelection.length > 0) {
        this.addSelection.forEach((item) => {
          this.addTableData.forEach((line, index) => {
            if (line.id === item.id) {
              this.addTableData.splice(index, 1);
              this.addMap[item.id] = false;
            }
          });
        });
      } else {
        this.$Message.error('请选择商品!');
      }
    },
    pushData() {

    },

  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.cardContainer {
  margin-bottom: 16px;
}
// .formItem{
//   display: flex
// }

</style>
